import { render, staticRenderFns } from "./ThePayment.vue?vue&type=template&id=0f475aff&scoped=true"
import script from "./ThePayment.vue?vue&type=script&lang=js"
export * from "./ThePayment.vue?vue&type=script&lang=js"
import style0 from "./ThePayment.vue?vue&type=style&index=0&id=0f475aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f475aff",
  null
  
)

export default component.exports